module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_vorgeschlagen_ro.4269d080.jpg";